// extracted by mini-css-extract-plugin
module.exports = {"sharebutton":"ShareSwitch_sharebutton__3Tc2p"};